import * as shopUrls from "./routes/shop/urls";
import * as subscriptionUrls from "./routes/subscription/urls";
import * as adminUserUrls from "./routes/user/urls";
import * as productUrls from "./routes/product/urls";
import * as newsUrls from "./routes/news/urls";
import * as notificationUrls from "./routes/notification/urls";
import * as advancedFunctionUrls from "./routes/advancedFunction/urls";
import * as ePaymentUrls from "./routes/e_payment/urls";

const URL_WHITELIST_DICT = {
  th: [],
  vn: [],
  id: [],
};

const SHARE_URLS = [
  // Owner
  shopUrls.ownerFrontendPath,
  shopUrls.ownerChangeMobileFrontendPath,
  shopUrls.ownerConfirmChangeMobileFrontendPath,
  shopUrls.ownerAdminChangeMobileFrontendPath,
  shopUrls.ownerAdminConfirmChangeMobileFrontendPath,
  shopUrls.ownerMergeShopFrontendPath,
  shopUrls.emailByShopFrontendPath,
  // News
  newsUrls.newsFrontendPath,
  newsUrls.newsCreateFrontendPath,
  newsUrls.newsEditFrontendPath,
  newsUrls.newsEditStatusFrontendPath,

  newsUrls.newsBannerFrontendPath,
  newsUrls.newsBannerCreateFrontendPath,
  newsUrls.newsBannerEditFrontendPath,
  newsUrls.newsBannerEditStatusFrontendPath,

  newsUrls.bannerFrontendPath,
  newsUrls.bannerEditFrontendPath,
  newsUrls.bannerCreateFrontendPath,
  // Admin User
  adminUserUrls.adminUserFrontendPath,
  adminUserUrls.adminUserEditFrontendPath,
  adminUserUrls.groupFrontendPath,
  adminUserUrls.groupEditFrontendPath,
  adminUserUrls.adminLogFrontendPath,

  // Shop
  shopUrls.shopFrontendPath,
  shopUrls.shopMenuListFrontendPath,
  shopUrls.shopMenuImportFrontendPath,
  shopUrls.shopMenuPresetFrontendPath,
  shopUrls.shopMenuDeleteFrontendPath,
  shopUrls.shopReportResendFrontendPath,
  shopUrls.shopDisableFrontendPath,
  shopUrls.shopDisableRequestFrontendPath,
  shopUrls.shopUnblockFrontendPath,
  shopUrls.shopUnblockRequestFrontendPath,
  shopUrls.shopUnblockForceRequestFrontendPath,
  shopUrls.shopPushDeviceListFrontendPath,
  shopUrls.shopLoginDisableFrontendPath,

  // Shop Login Whitelist
  shopUrls.shopLoginWhitelistFrontendPath,
  shopUrls.shopLoginWhitelistCreateFrontendPath,
  shopUrls.shopLoginWhitelistEditFrontendPath,

  // Notification
  notificationUrls.notificationFrontendPath,
  notificationUrls.notificationCreateFrontendPath,
  notificationUrls.notificationEditFrontendPath,
  notificationUrls.smsCreateFrontendPath,

  // Subscription
  subscriptionUrls.subsListFrontPath,
  subscriptionUrls.subsExtendInquiryFrontPath,
  subscriptionUrls.subsExtendConfirmFrontPath,
  subscriptionUrls.subsEditInquiryFrontPath,
  subscriptionUrls.subsEditConfirmFrontPath,
  subscriptionUrls.subsShopRevokeFrontPath,
  subscriptionUrls.orderListFrontPath,
  subscriptionUrls.paymentListFrontPath,
  subscriptionUrls.paymentDetailFrontPath,
  subscriptionUrls.subsActivateFrontPath,
  subscriptionUrls.subsActivateInquiryFrontPath,
  subscriptionUrls.subsActivateConfirmFrontPath,
  subscriptionUrls.freeTrialListFrontPath,
  subscriptionUrls.freeTrialEditFrontPath,

  // Product
  productUrls.productFrontendPath,
  productUrls.productCreateFrontendPath,
  productUrls.productEditFrontendPath,

  productUrls.machineLendingFrontendPath,
  productUrls.machineLendingExtendFrontendPath,
  productUrls.machineLendingBatchExtentFrontendPath,
  productUrls.machineLendingCreateFrontendPath,
  productUrls.machineLendingEditFrontendPath,
  productUrls.machineLendingReturnFrontendPath,

  productUrls.productOrderFrontendPath,

  productUrls.promotionFrontendPath,

  productUrls.appSubscriptionFrontendPath,
  productUrls.appSubscriptionUpdateFrontendPath,
  productUrls.appSubscriptionExtendFrontendPath,
  productUrls.appSubscriptionAdjustFrontendPath,

  // E payment
  ePaymentUrls.setupRequestFrontendPath,
  ePaymentUrls.setupRequestEditFrontendPath,

  // Advanced functions
  advancedFunctionUrls.functionSwitchFrontendPath,
  advancedFunctionUrls.functionSwitchHotSlaveFrontendPath,
  advancedFunctionUrls.functionSwitchFoodyIntegrationFrontendPath,
  advancedFunctionUrls.functionSwitchAutoAcceptFoodyOrdersFrontendPath,
  advancedFunctionUrls.functionSwitchEpaymentFrontendPath,
  advancedFunctionUrls.functionSwitchAssembledOrderLoadingInReportFrontendPath,
  advancedFunctionUrls.functionSwitchNewMenuServiceFrontendPath,
  advancedFunctionUrls.functionSwitchAddWhitelistFrontendPath,
  advancedFunctionUrls.functionSwitchRemoveWhitelistFrontendPath,
  advancedFunctionUrls.functionSwitchEditWhitelistFrontendPath,
  advancedFunctionUrls.premiumShopFrontendPath,
  advancedFunctionUrls.premiumShopUnmergeBranchFrontendPath,
  advancedFunctionUrls.premiumShopTransferPrimaryFrontendPath,
  advancedFunctionUrls.premiumShopDeactivateFrontendPath,
  advancedFunctionUrls.importFoodyMenuFrontendPath,
  advancedFunctionUrls.extendMembershipFrontendPath,
  advancedFunctionUrls.extendMembershipUpdateFrontendPath,
  advancedFunctionUrls.nowOchaShopsFrontendPath,
  advancedFunctionUrls.nowOchaShopsChangeDeliveryFrontendPath,

  advancedFunctionUrls.reminderConfigFrontendPath,
  advancedFunctionUrls.reminderConfigUpdateDetailFrontendPath,
  advancedFunctionUrls.reminderConfigUpdateEditFrontendPath,
  advancedFunctionUrls.reminderConfigDropDetailFrontendPath,
  advancedFunctionUrls.reminderConfigDropEditFrontendPath,
];

URL_WHITELIST_DICT["th"].push(
  // Popup Notification
  notificationUrls.popupNotificationFrontendPath,
  notificationUrls.popupNotificationCreateFrontendPath,
  notificationUrls.popupNotificationEditBackendPath,
  advancedFunctionUrls.dualScreenAdListFrontendPath,
  advancedFunctionUrls.dualScreenAdDetailFrontendPath,
  advancedFunctionUrls.dualScreenAdEditFrontendPath
);

export const URL_WHITELIST = new Set([
  ...URL_WHITELIST_DICT[process.env.REACT_APP_COUNTRY.trim()],
  ...SHARE_URLS,
]);



// WEBPACK FOOTER //
// ./src/config.js